import { gql } from 'urql';

const ADD_OPPORTUNITY_COMMENTS = gql`
  mutation AddOpportunityComment(
    $objects: [opportunity_comments_insert_input!]!
    $id: Int!
    $activity: String
    $timestamp: bigint
    $userId: Int
  ) {
    insert_opportunity_comments(objects: $objects) {
      returning {
        id
      }
    }

    insert_opportunities_activity_one(
      object: { activity: $activity, entity_id: $id, timestamp: $timestamp, user_id: $userId }
    ) {
      id
    }
  }
`;

export default ADD_OPPORTUNITY_COMMENTS;
